// TODO this creates a sort of circular dependency
import { renderer } from '../scene';

export enum Cursor {
  auto = 'auto',
  default = 'default',
  none = 'none',
  pointer = 'pointer',
  grab = 'grab',
  grabbing = 'grabbing',
}

export function setCursor(cursor: Cursor) {
  renderer.domElement.style.cursor = cursor;
}

export function unsetCursor() {
  renderer.domElement.style.cursor = Cursor.auto;
}
